import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { MUITextBox, ReactFormSelect } from 'components/FormHelpers/FormInputs';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { getEmptyValue, getUIDateFormat } from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import RegSteps from './RegSteps';
import { OpenInves } from './OpenInves';
import { ProtocolRelations } from './ProtocolRelations';
import OPENITRFProvideSetup from './OPENITRFProvideSetup';
import { Miscellaneous } from './Miscellaneous';
import GroupOpenPerson from './GroupOpenPerson';
import OpenSetupConfigs from './OpenSetupConfigs';

const GroupProtocolNumber = ({ state, handleChange }) => (
  <MUITextBox
    value={getEmptyValue(state && state.alias)}
    onChange={handleChange}
    validators={['maxStringLength:25']}
    errorMessages={['Maximum 25 characters allowed']}
    name="alias"
    title="Group Protocol Number"
  />
);

const Comments = ({
  state, handleChange
}) => (
  <MUITextBox
    multiline
    rowsMax="2"
    value={getEmptyValue(state && state.comments)}
    onChange={handleChange}
    validators={['maxStringLength:500']}
    errorMessages={['Maximum 500 characters allowed']}
    name="comments"
    title="Comments"
  />
);


const Step = ({ state, setState, steps }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [step, selStep] = useState(null);

  useEffect(() => {
    if (!_.isEmpty(steps)) {
      setSuggestions(steps);
    } else {
      setSuggestions([]);
    }
  }, [setSuggestions, steps]);

  const handleInputChange = val => {
    const lcVal = val && val.toLowerCase();
    setSuggestions(_.filter(steps,
      (item) => item.label.toLowerCase().includes(lcVal)));
  };

  useEffect(() => {
    if (state) {
      selStep(_.find(steps, (item) => state.step === item.value));
    } else {
      selStep({});
    }
  }, [selStep, steps, state]);

  return (
    <ReactFormSelect
      title="Step"
      name="step"
      validators={['required']}
      errorMessages={['Required Field']}
      options={suggestions && suggestions.slice(0, 20)}
      value={step || ''}
      onInputChange={handleInputChange}
      onChange={event => {
        selStep(event);
        setState({ ...state, step: event ? event.value : '', prlId: event ? event.prlId : '' });
      }}
    />
  );
};

const ReqOptions = [{
  label: 'Yes',
  value: true
}, {
  label: 'No',
  value: false
}];

const Required = ({ state, setState }) => {
  const [suggestions, setSuggestions] = useState(ReqOptions);
  const [req, selReq] = useState(null);

  const handleInputChange = val => {
    if (val) {
      setSuggestions(_.filter(suggestions,
        (item) => item.label.toLowerCase().includes(val.toLowerCase())));
    } else {
      setSuggestions(ReqOptions);
    }
  };

  useEffect(() => {
    if (state) {
      selReq(_.find(suggestions, (item) => state.isMandatory === item.value));
    } else {
      selReq({});
    }
  }, [selReq, suggestions, state]);

  return (
    <ReactFormSelect
      title="Is Mandatory"
      name="isMandatory"
      options={suggestions}
      value={req || ''}
      onInputChange={handleInputChange}
      validators={['required']}
      errorMessages={['Required Field']}
      onChange={event => {
        selReq(event);
        setState({ ...state, isMandatory: event ? event.value : '' });
      }}
    />
  );
};

const Days = ({ state, handleChange }) => (
  <MUITextBox
    title="Number of Days"
    value={getEmptyValue(state && state.delayedEnrollDays)}
    onChange={handleChange}
    validators={['matchRegexp:^[0-9]+$']}
    errorMessages={['Please enter numeric value']}
    name="delayedEnrollDays"
  />
);

const Start = ({
  state, setState, handleDateChange
}) => (
  <MUIDatePicker
    title="Start Date"
    name="startDate"
    onChange={handleDateChange('startDate')}
    value={(state && state.startDate) ? getUIDateFormat(state.startDate) : ''}
    popperPlacement="top-start"
  />
);

const End = ({
  state, setState, handleDateChange
}) => {
  ValidatorForm.addValidationRule('minDate', value => !(value) || (value !== 'Invalid date' && value >= getUIDateFormat(state.startDate)));
  return (
    <MUIDatePicker
      title="End Date"
      name="endDate"
      onChange={handleDateChange('endDate')}
      value={(state && state.endDate) ? getUIDateFormat(state.endDate) : ''}
      selected={getUIDateFormat(state.cmEffectiveDate)}
      validators={(state && state.startDate && state.endDate) && ['minDate']}
      errorMessages={(state && state.startDate && state.endDate) && [
        'End date should be greater than start date'
      ]}
      popperPlacement="top-start"
    />
  );
};


export {
  RegSteps,
  OpenInves,
  ProtocolRelations,
  OPENITRFProvideSetup,
  Miscellaneous,
  GroupOpenPerson,
  OpenSetupConfigs,
  GroupProtocolNumber,
  Required,
  Step,
  Days,
  Start,
  End,
  Comments
};
